import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WMSItemLabelLinkContainerModel } from "../../../../../models/aggregates/warehouse/index";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";
import { BaseApiPublicLoginTemplateService } from "../shared/base-api-public-login-template.service";
import { Observable } from "rxjs";
import { Pagination, ApiVisa, PagingResponseModel } from "../shared";

@Injectable({ providedIn: "root" })
export class WMSItemLabelLinkService extends BaseApiTemplateService<WMSItemLabelLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-labels-link/" +
      BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-labels-link/" +
      BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

  public getLinkByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        "wms-item-labels-link/query/" +
        BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    }
    const UrlByCriteria = this.apiUrl + "?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
